import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ObjectStore } from 'src/app/acl-data/object-store/object-store.dto';
import { ObjectStoreService } from 'src/app/acl-data/object-store/object-store.service';
import { UserDataService } from 'src/app/acl-data/userData/user-data.service';
import { LoginService } from 'src/app/login/services/login-service.service';
import { IMenuItem } from 'src/app/navigation/menuInterfaces/menu-item.interface';
import { TopnavInfoService } from 'src/app/navigation/menuInterfaces/topnav-info.service';
import { ACLRouteDataService } from './acl-route-data.service';

function mapRole(osName: string, item: IMenuItem) {
    const result = { ...item };
    if (result.needsRole) {
        result.needsRole = result.needsRole.map(role => `${osName}:${role}`);
    }
    if (result.subMenu) {
        result.subMenu = item.subMenu.map(menu => mapRole(osName, menu));
    }

    return result;
}

function mapOSData(routeData: IMenuItem, os: ObjectStore[]) {
    // console.group('Template');

    const newRoute = os.map(v => {
        let result = {
            ...routeData,
            id: v.symbolicName,
            description: v.name,
            path: v.symbolicName,
        };

        result = mapRole(v.symbolicName, result);

        // console.log('Result', result);
        return result;
    });

    // console.log('Returing', newRoute);
    // console.groupEnd();
    return newRoute;
}

@Injectable({
    providedIn: 'root',
})
export class ACLInfoService extends TopnavInfoService {
    constructor(
        private router: Router,
        private aclRouteData: ACLRouteDataService,
        private loginService: LoginService,
        private objectStoreService: ObjectStoreService,
        private userDataService: UserDataService
    ) {
        super(
            router,
            objectStoreService.entities$.pipe(
                map(os => mapOSData(aclRouteData.routeData, os)),
                filter(v => v && v.length > 0)
            ),
            loginService
        );
    }

    public getLogoFilename(): Observable<string> {
        return of('assets/images/aspen-logo.svg');
    }

    public getUserName(): Observable<string> {
        return this.userDataService.userData$.pipe(map(v => v.fullname));
    }

    // public getFullUserName(): Observable<string> {
    //     return this.userDataService.userData$.pipe(map(v => v.fullname));
    // }

    public getUserRoles(): Observable<string[]> {
        if (!this.objectStoreService) {
            return of([]); // We havent loaded any roles yet
        }
        return this.objectStoreService.entities$.pipe(
            map(v =>
                v
                    .map(os =>
                        os.superUser
                            ? `${os.symbolicName}:SuperUser`
                            : undefined
                    )
                    .filter(v => v !== undefined)
            )
            // tap(v => console.log('Roles', v))
        );
    }

    public getModules(): Observable<IMenuItem[]> {
        return this.objectStoreService.entities$.pipe(
            map(os => mapOSData(this.aclRouteData.routeData, os)),
            filter(v => v && v.length > 0)
        );
    }
}
